export default __webpack_public_path__ + "static/media/change.6f930341.svg";